import get from 'lodash/get'
import {initialItemState} from '../reducers/data/lists'

export const getListParams = (state, key) => get(state, ['data', 'lists', key, 'params'], initialItemState)
export const isLoadingList = (state, key) => get(state, ['data', 'lists', key, 'loading'])
export const getListItems = (state, key) => get(state, ['data', 'lists', key, 'items'])


// WEBPACK FOOTER //
// ./src/selectors/lists.js